import React from 'react';
import { isChecked } from '@/utils/resultsHelper';
import ToggleNoLabel from '@/components/ToggleNoLabel';

const CohortFilterValuesToggle = ({
  filterUUID,
  values,
  disabled,
  onChange,
}) => (
  <ToggleNoLabel
    className="aridhia-cohort-filter-values-toggle"
    disabled={disabled}
    checked={isChecked(values[0])}
    onClick={() => onChange([!isChecked(values[0])])}
    label={filterUUID}
  />
);

export default CohortFilterValuesToggle;
